(function () {
    'use strict';
    angular.module('Services').service('HistoryTransactionTableService', HistoryTransactionTableService);
    HistoryTransactionTableService.$inject = [
        '$filter',
        'toastr',
        '$uibModal',
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$routeParams',
        '$rootScope',
        'ConfirmationModalFactory'
    ];

    function HistoryTransactionTableService(
        $filter,
        toastr,
        $uibModal,
        TableLiteFactory,
        $location,
        AffiliateService,
        $routeParams,
        $rootScope,
        ConfirmationModalFactory
    ) {
        return function (transactionData) {

            const confirmMsgBox = new ConfirmationModalFactory({}, {
                message: 'messages.warning.approveTransaction.MESSAGE',
                code: 'messages.warning.approveTransaction.CODE'
            });

            const rejectMsgBox = new ConfirmationModalFactory({}, {
                message: 'messages.warning.rejectTransaction.MESSAGE',
                code: 'messages.warning.rejectTransaction.CODE'
            });

            const tableData = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtract: true,
                    tableHeight: '400px'

                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-success',
                        label: 'Export',
                        tooltip: 'Export',
                        onClick: function () {
                            exportBtn();
                        }
                    }, {
                        class: 'btn-right btn-green',
                        label: 'Approve',
                        tooltip: 'Approve',
                        onClick: function () {

                            let selected = tableData.data.filter(item => {
                                return item.isSelected;
                            });

                            if (!selected.length) {
                                toastr.warning('Please Select a transaction to process.')
                                return
                            }

                            confirmMsgBox.getInstance().result.then(cond => {
                                if (cond) {
                                    approvedTransactionBtn();
                                }
                            })

                        }
                    }, {
                        class: 'btn-danger',
                        label: 'Reject',
                        tooltip: 'Reject',
                        onClick: function () {

                            let selected = tableData.data.filter(item => {
                                return item.isSelected;
                            });

                            if (!selected.length) {
                                toastr.warning('Please Select a transaction to process.')
                                return
                            }

                            rejectMsgBox.getInstance().result.then(cond => {
                                if (cond) {
                                    rejectTransactionBtn();
                                }

                            });
                        }
                    }]
                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'Client Name',
                        viewName: 'clientName',
                        filterName: 'companyReferred.companyName',

                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Promo Code',
                        viewName: 'code',
                        filterName: 'promoCode.code',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Discount Condition',
                        viewName: 'conditions'
                    },
                    {
                        label: 'Commencement Date',
                        viewName: 'createdDate',
                        filterName: 'createdDate',
                        filter: {
                            type: 'datePicker',
                            placeholder: 'Search',
                            useArray: true,
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Shipments',
                        viewName: 'consignmentId'
                    },

                    {
                        label: 'Discount',
                        viewName: 'shipmentDiscountedAmount',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Sub-Affiliate',
                        viewName: 'subAffiliate',
                        filterName: 'userMarketing.id',
                        // filter: {
                        //     type: 'text',
                        //     placeholder: 'Search',
                        //     onSubmit: header => {
                        //         sendRequest(evaluateFilter(header));
                        //     }
                        // },
                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Commision Per Booking',
                        viewName: 'commission',
                        filterName: 'commissionDetails.total',

                        headerFn: function () {
                            sort(this.filterName);
                        }
                    },

                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getTransactionHistory,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        'company_referred_id': transactionData.companyReferred.companyId,
                        size: 5,
                        page: 0,
                        sort: 'id,desc',
                        approved: false
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {

                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.code = item.promoCode.code;
                    item.createdDate = $filter('date')(new Date(item.promoCode.createdDate), "yyyy-MM-dd");
                    item.shipmentDiscountedAmount = item.discountDetails.discountTotal;
                    item.subAffiliate = `${item.userMarketing.firstName} ${item.userMarketing.lastName}`;
                    item.clientName = item.companyReferred.companyName;
                    item.commission = `${$filter('bbaCurrency')(item.commissionDetails.total, '')}`;
                    item.conditions = item.promoCode.promoCondition
                    item.createdDate = $filter('date')(new Date(item.createdDate), "yyyy-MM-dd");

                    tableData.data.push(item);
                });
            };

            function exportBtn() {
                AffiliateService.exportByReferred('export-referred', res => {
                    toastr.success('File exported succesfully.')
                }, err => {
                    toastr.error(err.message)
                }, { company_referred_id: transactionData.id, approved: true })


            };

            function approvedTransactionBtn() {
                const historyTransaction = getSelectedTransaction('approved');
                AffiliateService.approveReport(transactionData.id,
                    res => {
                        toastr.success('Success');
                        tableActions.sendRequest();
                    }, err => {
                        toastr.error(err.message);
                        tableActions.sendRequest()
                    }, historyTransaction)
            }

            function rejectTransactionBtn() {
                const historyTransaction = getSelectedTransaction('rejected');
                AffiliateService.approveReport(transactionData.id,
                    res => {
                        toastr.success('Success');
                        tableActions.sendRequest();
                    }, err => {
                        toastr.error(err.message);
                        tableActions.sendRequest()
                    }, historyTransaction)
            }

            function getSelectedTransaction(status) {
                const payload = [];
                let selected = tableData.data.filter(item => {
                    return item.isSelected;
                });
                selected.forEach(item => {
                    payload.push({ id: item.id, status: status })
                });


                return payload;
            }

            this.tableData = tableData;
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/HistoryTransactionTableService.js